import { usePatientParamContext } from "@/modules/patients/stores/PatientParamProvider"

const usePatientParam = () => {
  const { patientId } = usePatientParamContext()
  return patientId
}

export { usePatientParam }
